import React, { useId } from 'react';

import { useGraphQLQuery } from '@betterment/graphql';

import { AccountsFilter } from './AccountsFilter';
import { BalanceChart } from './BalanceChart';
import { BalanceDetails } from './BalanceDetails';
import { UserBalancePerformanceDocument } from './graphql/userPerformanceBalance.generated';

import { DateRangeOption } from '../../../../graphql/schema';
import { PerformanceAccountsQuery } from '../../graphql/performanceAccounts.generated';

export const Balance: React.FC<{
  dateRangeOption: DateRangeOption;
  accounts: PerformanceAccountsQuery['performance']['accounts'];
}> = ({ dateRangeOption, accounts }) => {
  const describeId = useId();
  const { data } = useGraphQLQuery(UserBalancePerformanceDocument, {
    variables: { dateRangeOption },
    throwOnError: true,
  });

  let startDate: Date | undefined;
  let endDate: Date | undefined;

  if (data?.performance.history) {
    const { history } = data.performance;
    if (history.timeSeries.length > 0) {
      startDate = new Date(history.timeSeries[0].date);
      endDate = new Date(history.timeSeries[history.timeSeries.length - 1].date);
    }
  }

  return (
    <>
      <AccountsFilter accounts={accounts} />
      <BalanceChart history={data?.performance.history} balanceDetailsId={describeId} />
      <BalanceDetails id={describeId} totals={data?.performance.totals} startDate={startDate} endDate={endDate} />
    </>
  );
};
